import gql from 'graphql-tag'

export default gql`
  query getFolderTechpack($id: String!, $companyId: String!, $folderId: String!) {
    getFolderTechpack(id: $id, companyId: $companyId, folderId: $folderId) {
      _id
      name
      link
      metadata {
        ContentLength
        ContentType
      }
      attachments {
        _id
        link
        name
        metadata {
          ContentLength
          ContentType
        }
      }
      product {
        _id
        name
        code
      }
    }
  }
`
